import {
  AUSTRALIA,
  IRELAND,
  UNITED_KINGDOM,
  UNITED_STATES,
} from 'config/countries-data'

export const PAID_AD = 'A paid ad'
export const INFLUENCER = 'An influencer'
export const STACEY_SOLOMON = 'Stacey Solomon'
export const REBECCA_JUDD = 'Rebecca Judd'
export const TAMMIN_SURSOK = 'Tammin Sursok'
export const TIA_MOWRY = 'Tia Mowry'
export const NOT_SURE = "I'm not sure"
export const SUB_ATTRIBUTION_OPTIONS = [PAID_AD, INFLUENCER, NOT_SURE]
const GB_SUB_ATTRIBUTION_OPTIONS = [
  PAID_AD,
  INFLUENCER,
  STACEY_SOLOMON,
  NOT_SURE,
]
const AU_SUB_ATTRIBUTION_OPTIONS = [
  PAID_AD,
  REBECCA_JUDD,
  TAMMIN_SURSOK,
  NOT_SURE,
]
const US_SUB_ATTRIBUTION_OPTIONS = [PAID_AD, INFLUENCER, TIA_MOWRY, NOT_SURE]

const SUB_ATTRIBUTION_OPTIONS_BY_COUNTRY: Record<string, string[]> = {
  [UNITED_KINGDOM]: GB_SUB_ATTRIBUTION_OPTIONS,
  [IRELAND]: GB_SUB_ATTRIBUTION_OPTIONS,
  [AUSTRALIA]: AU_SUB_ATTRIBUTION_OPTIONS,
  [UNITED_STATES]: US_SUB_ATTRIBUTION_OPTIONS,
}

type SubAttributionOption =
  | typeof PAID_AD
  | typeof INFLUENCER
  | typeof STACEY_SOLOMON
  | typeof REBECCA_JUDD
  | typeof TAMMIN_SURSOK
  | typeof TIA_MOWRY
  | typeof NOT_SURE

export const SUB_ATTRIBUTION_ANALYTICS_OPTIONS: Record<
  SubAttributionOption,
  string
> = {
  [PAID_AD]: 'Ad',
  [INFLUENCER]: 'Influencer',
  [STACEY_SOLOMON]: 'Stacey Solomon',
  [REBECCA_JUDD]: 'Rebecca Judd',
  [TAMMIN_SURSOK]: 'Tammin Sursok',
  [TIA_MOWRY]: 'Tia Mowry',
  [NOT_SURE]: "I'm not sure",
}

export const TRANSLATED_SUB_ATTRIBUTION_OPTIONS: Record<
  SubAttributionOption,
  string
> = {
  [PAID_AD]: 'new_email_capture.attribution.sub_options.paid_ad',
  [INFLUENCER]: 'new_email_capture.attribution.sub_options.influencer',
  [STACEY_SOLOMON]: 'new_email_capture.attribution.channels.stacey_solomon',
  [REBECCA_JUDD]: 'new_email_capture.attribution.channels.rebecca_judd',
  [TAMMIN_SURSOK]: 'new_email_capture.attribution.channels.tammin_sursok',
  [TIA_MOWRY]: 'new_email_capture.attribution.channels.tia_mowry',
  [NOT_SURE]: 'new_email_capture.attribution.sub_options.not_sure',
}

export const EXPANDED_CHANNELS = ['Instagram', 'Facebook', 'Tiktok']

export function getSubAttributionOptions(country: string): string[] {
  return SUB_ATTRIBUTION_OPTIONS_BY_COUNTRY[country] ?? SUB_ATTRIBUTION_OPTIONS
}
